import React from "react";
import {PlannerTask, PlannerTaskSystemStatus} from "../../../../../../../models/planner/planner";
import {PlannerTasksViewAction} from "../task.view.action";
import {Action} from "../../model";
import {plannerService} from "../../../../../../../services/planner/planner.service";
import {SystemUserRole} from "../../../../../../../models/users/user/system.user-with-attributes";

export const PlannerTasksViewDoneAction: Action = ({task, reload}) => {

    const run = async () => {
        await plannerService.complete(task.id);
        reload();
    }

    return (
        <PlannerTasksViewAction
            title={"DONE"}
            run={run}
        />
    )
}

PlannerTasksViewDoneAction.isApplicable = (task: PlannerTask, role: SystemUserRole) => {
    return role === "superior" && [
        PlannerTaskSystemStatus.ON_REVIEW
    ].includes(task.status);
}